const EmployeeActiveFilter = Object.freeze({
    ALL: 'ALL',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
});

const EmployeeGroupFilter = Object.freeze({
    ALL: 'ALL',
    EMPLOYEE: 'EMPLOYEE',
    NONEMPLOYEE: 'NONEMPLOYEE',
});

export {
    EmployeeActiveFilter,
    EmployeeGroupFilter,
};
